/* eslint-disable max-len */
import styled from 'styled-components';
import InternalOutIconDark from '../../assets/images/internal-out-icon.svg';
import InternalOutIconLight from '../../assets/images/internal-out-icon-light.svg';

const InternalOutIcon = styled.span`
  background: ${(props) =>
    props.theme.palette.type === 'dark'
      ? `url("${InternalOutIconDark}") no-repeat left center`
      : `url("${InternalOutIconLight}") no-repeat left center`};
  background-size: 23px 21px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  height: 21px;
  width: 23px;
`;

export default InternalOutIcon;
